module.exports = __webpack_public_path__ + "static/media/craft_start_second.0d901ac6.mp3";